import React from 'react';
import { BookOpenIcon, EyeIcon, ShieldCheckIcon, PlusCircleIcon } from 'lucide-react';
import { mockKBArticles, mockSuggestedArticles } from '../data/mockData';
export function KnowledgeBase() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6" data-id="element-4">
      <div className="flex items-center mb-6" data-id="element-5">
        <BookOpenIcon className="w-5 h-5 text-blue-500 mr-2" data-id="element-6" />
        <h2 className="text-lg font-bold text-gray-900" data-id="element-7">
          Knowledge Base Effectiveness
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-8">
        <div data-id="element-9">
          <h3 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-10">
            Top Performing Articles
          </h3>
          <div className="space-y-3" data-id="element-11">
            {mockKBArticles.map(article => <div key={article.id} className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg border border-transparent hover:border-gray-100 transition-colors" data-id="element-12">
                <div className="flex-1 pr-4" data-id="element-13">
                  <h4 className="text-sm font-medium text-gray-900 truncate" title={article.title} data-id="element-14">
                    {article.title}
                  </h4>
                  <div className="flex items-center mt-1 space-x-4 text-xs text-gray-500" data-id="element-15">
                    <span className="flex items-center" data-id="element-16">
                      <EyeIcon className="w-3 h-3 mr-1" data-id="element-17" />{' '}
                      {article.views.toLocaleString()} views
                    </span>
                    <span className="flex items-center text-green-600" data-id="element-18">
                      <ShieldCheckIcon className="w-3 h-3 mr-1" data-id="element-19" /> ~
                      {article.deflectedTickets} tickets deflected
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        <div data-id="element-20">
          <h3 className="text-sm font-semibold text-gray-700 mb-4" data-id="element-21">
            Suggested New Articles
          </h3>
          <p className="text-xs text-gray-500 mb-4" data-id="element-22">
            Based on recent unresolved ticket trends
          </p>
          <div className="space-y-3" data-id="element-23">
            {mockSuggestedArticles.map((suggestion, idx) => <div key={idx} className="flex items-center justify-between p-3 bg-blue-50 rounded-lg border border-blue-100" data-id="element-24">
                <div className="flex-1 pr-4" data-id="element-25">
                  <h4 className="text-sm font-medium text-blue-900" data-id="element-26">
                    {suggestion.issue}
                  </h4>
                  <div className="flex items-center mt-1 space-x-3 text-xs" data-id="element-27">
                    <span className="text-blue-700 font-medium" data-id="element-28">
                      {suggestion.count} recent tickets
                    </span>
                    <span className="text-red-600 font-medium" data-id="element-29">
                      {suggestion.trend} trend
                    </span>
                  </div>
                </div>
                <button className="flex items-center text-xs font-medium text-blue-700 hover:text-blue-900 bg-white px-2 py-1.5 rounded border border-blue-200 hover:bg-blue-50 transition-colors" data-id="element-30">
                  <PlusCircleIcon className="w-3 h-3 mr-1" data-id="element-31" />
                  Draft
                </button>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}